import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from "../../utils/httpsRequest";

export const fetchCustomers = createAsyncThunk(
  "customer/fetchCustomers",
  async (arg) => {
    return httpRequest(`${BASE_URL}/Customers?SearchText=${arg.searchText}&PageSize=${arg.pageSize}&PageNumber=${arg.pageNumber}`);
  }
)

const customerSlice = createSlice({
  name: 'customer',
  initialState: {
    customers: [],
    loading: false,
    error: null,
  },
  reducers:  {
    setCustomers(state, action) {
      state.customers.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.loading = false;
        state.customers = action.payload;
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { setCustomers } = customerSlice.actions;
export default customerSlice.reducer;

